import { Observable } from 'rxjs';

import { RegistrationData } from '../../model/login-register.model';

export abstract class RegistrationStartAdapter {
  abstract loadRegistrationStart(request: RegistrationData): Observable<void>;
}
